var map = {
	"./black/unMute_camera.png": "Letc",
	"./blue/unMute_camera.png": "jy3l",
	"./white/unMute_camera.png": "IH94"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ez+B";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/unMute_camera\.png$
// module id = ez+B
// module chunks = 24